import type { BaseButtonVariant } from '@csscompany/csds-components/types/components/BaseButton/types';
import React from 'react';

import { Button } from '../components/ui';
import { ShortcodeSerializer } from '../hooks/useShortcodes';

export const wpBlogSerializer: ShortcodeSerializer = {
  button: ({ type, label, variant, utm_content }) => {
    const variants: Record<BaseButtonVariant, string> = {
      danger: 'danger',
      inverse: 'inverse',
      primary: 'primary',
      secondary: 'secondary',
    };

    switch (type) {
      case 'typeform':
        return (
          <Button
            variant={variants[variant] || 'primary'}
            size="lg"
            globalTypeform
            buttonClassName="header_cta !py-2"
            utm_content={utm_content}>
            {label || 'Learn more'}
          </Button>
        );
    }
  },
};
